module.exports = __webpack_public_path__ + "img/weibo.0c38fbb2.svg";